// extracted by mini-css-extract-plugin
export default {"personalImage":"AddFile_personalImage__dfdKB"};